import { useDeleteReportConfiguration } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'REPORTS.MAILINGS';
const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE_REPORT_MAILING';

type UseDeleteReportMailingReturnType = {
  handleDeleteReportMailing: (configurationId: string) => void;
};

// The configurations refetch is triggered by the generated mutation (see orval.config.ts).
export const useDeleteReportMailing = (): UseDeleteReportMailingReturnType => {
  const { t } = useTranslation();
  const { showSuccess, showError } = useNotification();
  const { mutate: mutateDelete } = useDeleteReportConfiguration<AxiosError>();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
      error,
    });
  };

  const onConfirm = (configurationId: string): void => {
    mutateDelete({ configurationId }, { onSuccess, onError });
  };

  const handleDeleteReportMailing = (configurationId: string): void => {
    modals.openConfirmModal({
      title: t(`${TRANS_PATH}.DELETE_CONFIRMATION_TITLE`),
      labels: {
        confirm: t(`${TRANS_PATH}.DELETE_CONFIRM_BUTTON`),
        cancel: t('CANCEL_BUTTON'),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm: () => onConfirm(configurationId),
    });
  };

  return { handleDeleteReportMailing };
};
